// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__LEGnn","total":"AdvancePaymentDetails_total__PdJBw","edit":"AdvancePaymentDetails_edit__CiYfW"};